import React from "react";
import {
  AzureMap,
  AzureMapHtmlMarker,
  AzureMapsContext,
  IAzureMapOptions,
  IAzureMapsContextProps,
} from "react-azure-maps";
import { AuthenticationType } from "azure-maps-control";
import "azure-maps-control/dist/atlas.min.css";
import { useTheme } from "@mui/material/styles";
import { IAddress } from "../../data/Address";

interface IMapsAtlasProps {
  address: IAddress | null;
}

const option: IAzureMapOptions = {
  authOptions: {
    authType: AuthenticationType.subscriptionKey,
    subscriptionKey: process.env.REACT_APP_AZURE_MAPS_SUBSCRIPTION_KEY!,
  },
  view: "Auto",
};

export default function MapsAtlas({ address }: IMapsAtlasProps) {
  const { mapRef } = React.useContext<IAzureMapsContextProps>(AzureMapsContext);
  const primary = useTheme().palette.primary.main;

  React.useEffect(() => {
    if (mapRef) {
      mapRef.setCamera({
        center: [address?.position?.longitude, address?.position?.latitude],
        bounds: [
          address?.viewport?.west ?? -180,
          address?.viewport?.south ?? -89,
          address?.viewport?.east ?? 180,
          address?.viewport?.north ?? 90,
        ],
        padding: 30,
      });
    }
  }, [mapRef, address]);

  return (
    <AzureMap options={option}>
      {address?.position?.latitude != null &&
      address?.position?.longitude != null ? (
        <AzureMapHtmlMarker
          options={{
            color: primary,
            position: [address.position.longitude, address.position.latitude],
          }}
        />
      ) : (
        []
      )}
    </AzureMap>
  );
}
